var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('h1',[_vm._v("IT Locked Orders")]),_vm._v(" "),_vm._l((_vm.locks),function(lock){return _c('p',{key:lock.num},[_c('router-link',{attrs:{"to":{ name: 'View Order', params: {id: lock.num} }}},[_vm._v(_vm._s(lock.num))]),_vm._v(" - \n    "),_c('em',[_vm._v(_vm._s(lock.locked_by))])],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// /node_modules/vue-loader/lib/template-compiler?{"id":"data-v-035bc409","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/node_modules/vue-loader/lib/selector.js?type=template&index=0!/src/components/sales-order/reports/LockedOrders.vue
// module id = null
// module chunks = 